import classNames from 'classnames';

import * as Styles from './ErrorMessage.styles';

const ErrorMessage = ({ message, type = 'error', variant, className = '' }) => {
  if (!message) {
    return null;
  }

  if (variant === 'alert') {
    return <Styles.Alert severity={type}>{message}</Styles.Alert>;
  }

  return (
    <div
      className={classNames(
        'text-sm  mt-1',
        type === 'error' ? 'text-red-600 dark:text-red-400' : 'text-green-500',
        className
      )}
    >
      {message}
    </div>
  );
};

export default ErrorMessage;
